import React, { createContext, useContext, useMemo, useState } from 'react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'

import { palette as basePalette, createAppTheme } from './index'

const ThemeControllerContext = createContext({
  primaryHex: basePalette.primary.main,
  setPrimaryHex: () => {},
})

export const useThemeController = () => useContext(ThemeControllerContext)

export const ThemeProvider = ({ children }) => {
  const [primaryHex, setPrimaryHex] = useState(basePalette.primary.main)

  const theme = useMemo(() => createAppTheme(primaryHex), [primaryHex])

  const controller = useMemo(
    () => ({ primaryHex, setPrimaryHex }),
    [primaryHex]
  )

  return (
    <ThemeControllerContext.Provider value={controller}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeControllerContext.Provider>
  )
}

export default ThemeProvider
